import ContactUsSection from "./ContactUsSection";
import MapSection from "./MapSection";
import '../../assets/css/contactus.css';

export default function ContactUs() {
    return (
        <> 
            <ContactUsSection />
            <MapSection />
        </>
    );
}